<section class="shift-section">
  <div class="shift-header">
    Select a time to order
  </div>
  <div *ngFor="let shift of flavorShifts">
    <div class="shift-item">
      <div>
        {{ formatDateString(shift.day) }}: {{ shift.start_time }} - {{ shift.end_time }}
      </div>
      <button class="google-map-order-btn" (click)="selectShift(shift)">Start Order</button>
    </div>
  </div>
</section>
